import {
    reactive, ref, computed, watch,
} from 'vue';
import { useI18n } from 'vue-i18n';
import shareImgM from '@/assets/images/launchpad/share-bg-m_2.png';
import shareImgWeb from '@/assets/images/launchpad/share-bg-web_2.png';
import { ready, getByGlobalsComponent } from '@/hooks/uniframe';
import store from '@/store';
import { replace } from '@/locales/i18n';

const state = reactive({
    shareObj: null,
});
const loading = ref(true);
const codeLoading = ref(true);

const isH5 = window.sfe.isMobile && !window.sfe.isApp;
if (isH5) {
    loading.value = false;
    codeLoading.value = false;
} else {
    ready().then(async () => {
        const ins = await getByGlobalsComponent('share');
        state.shareObj = ins;
        loading.value = false;
    });

    watch(() => store.state.user.userstate, (val) => {
        if (val === -1) codeLoading.value = false;
        if (val !== 1) return;
        store.dispatch('user/GET_INVITE_CODE').finally(() => {
            codeLoading.value = false;
        });
    }, { immediate: true });
}

export function useShare() {
    const { t } = useI18n();
    const isM = window.sfe.isMobile || window.sfe.isApp;
    const code = computed(() => store.state.user.inviteCode);
    const btnLoading = computed(() => loading.value || codeLoading.value);
    const urlUtm = 'sa_utm_ci=AD0003&utm_source=ref&sa_utm_channel=ref_';

    const link = computed(() => {
        const { origin } = window.location;
        const path = isM ? replace('/trade/spot/m/launchpad') : replace('/trade/spot/launchpad');
        const linkWhole = code.value ? `${origin}${path}?ref=${encodeURIComponent(code.value)}&${urlUtm}` : `${origin}${path}?${urlUtm}`;
        return linkWhole;
    });

    const clickShare = ({ isOngoing = 0 }) => {
        if (btnLoading.value) return;
        if (isH5) {
            loading.value = true;
            window.byAppsFlyers?.triggerOneLink(`bybitapp://open/web?url=${encodeURIComponent(window.location.href)}`).finally(() => {
                loading.value = false;
            });
            return;
        }
        const share = state.shareObj;
        // 图片内容文案
        const contentDesc = isOngoing ? `<span>${t('lpn_invite_ad')}</span>` : t('lpn_invite_ad2');
        share.update({
            config: {
                code: code.value,
                posterStyle: ['horizontal', 'vertical'],
                link: link.value,
                content: `${t('lpn_share_text', { link: link.value })}`,
                contentLabel: t('lpn_share_text_label'),
                poster: [
                    {
                    // 海报模板
                        template: 'default',
                        // 海报数据
                        templateData: {
                            backgroundImage: {
                                vertical: shareImgM,
                                horizontal: shareImgWeb,
                            },
                            // 自定义内容文案
                            content: {
                                desc: contentDesc,
                            },
                            bottom: {
                                showCode: true,
                            },
                        },
                    },
                ],
            },
            visible: true,
        });
    };

    return {
        clickShare,
        loading: btnLoading,
    };
}
